import { render, staticRenderFns } from "./automatiCall.vue?vue&type=template&id=063eb76a&scoped=true&"
import script from "./automatiCall.vue?vue&type=script&lang=ts&"
export * from "./automatiCall.vue?vue&type=script&lang=ts&"
import style0 from "./automatiCall.vue?vue&type=style&index=0&id=063eb76a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063eb76a",
  null
  
)

export default component.exports